import { render, staticRenderFns } from "./DashboardReferrals.vue?vue&type=template&id=2c99313c&scoped=true"
import script from "./DashboardReferrals.vue?vue&type=script&lang=js"
export * from "./DashboardReferrals.vue?vue&type=script&lang=js"
import style0 from "./DashboardReferrals.vue?vue&type=style&index=0&id=2c99313c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99313c",
  null
  
)

export default component.exports